import { HeroBannerWithBreadcrumbContent } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/HeroBannerWithBreadcrumb/components/HeroBannerWithBreadcrumbContent"
import { HeroBannerWithBreadcrumbProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { generateResponsiveCSS } from "../../../lib/helper"

export const RenderConfig: ComponentConfig<HeroBannerWithBreadcrumbProps> = {
  render: ({ breadcrumb, image, title, className, styles, responsiveType }) => {
    const id = `hero-banner-with-breadcrumb-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType || "desktopFirst")

    return (
      <>
        {responsiveCSS}
        <HeroBannerWithBreadcrumbContent
          id={id}
          breadcrumb={breadcrumb}
          image={image}
          title={title}
          className={className}
        />
      </>
    )
  },
}
